import type React from 'react'
import type {SearchResults, SearchResultsType} from '../../types/blackbird-types'
import {clsx} from 'clsx'
import {LightBulbIcon} from '@primer/octicons-react'
import {useStableRandom} from '@github-ui/use-stable-random'
import styles from './MiniTip.module.css'

interface Tip {
  content: React.ReactElement | number | string
  show: SearchResultsType[]
}

const tips: Tip[] = [
  {
    content: (
      <>
        Press the <span className={clsx(styles.kbdWrapper, 'hx_kbd')}>/</span> key to activate the search input again
        and adjust your query.
      </>
    ),
    show: [
      'code',
      'codelegacy',
      'repositories',
      'commits',
      'issues',
      'pullrequests',
      'discussions',
      'registrypackages',
      'topics',
      'wikis',
      'users',
      'marketplace',
    ],
  },
  {
    content: 'Restrict your search to the title by using the in:title qualifier.',
    show: ['issues', 'pullrequests'],
  },
]

export default function MiniTip({payload}: {payload: SearchResults}) {
  const type = payload.type
  const tipsForType = tips.filter(tip => tip.show.includes(type))
  const tipIndex = useStableRandom({max: tipsForType.length || 1})
  const randomTip = tipsForType[tipIndex]

  if (!randomTip) {
    return null
  }
  return (
    <div className={styles.container}>
      <span className={styles.proTipLabel}>
        <LightBulbIcon size={16} className={styles.proTipIcon} />
        <span className={styles.proTipText}>ProTip!</span>&nbsp;
      </span>
      <span>{randomTip.content}</span>
    </div>
  )
}
